<div class="empty-state">
  <p>{{ title | translate }}</p>
</div>
